import {isEmail, isFullWidth} from 'validator';

export const isValidEmail = (value: string): boolean => {
    return isEmail(value) && !isFullWidth(value);
};
